<script>
  import { blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link, links } from "svelte-routing";

  export let block;
</script>

<section id="values" class="values">

  <div class="container" data-aos="fade-up">

    <header class="section-header">
      <h2>{text(block, 'preheadline')}</h2>
      <p>{text(block, 'headline')}</p>
    </header>

    <div class="row justify-content-center">

      {#each blocklist(block, 'features') as item}
        <div class="col-lg-4" style="margin-bottom: 30px;" data-aos="fade-up" data-aos-delay="200">
          <a href="{url(item, 'link')}" use:link>
          <div class="box">
            <img src="{image(item, 'picture', [null, 400])}" class="img-fluid" style="height: 250px;" alt="">
            <h3 style="height: 4em;">{text(item, 'title')}</h3>
            <p>{@html richtext(item, 'body')}</p>
          </div>
          </a>
        </div>
      {/each}
    
    </div>

  </div>

</section>
